import { isAccessedFromQBurstApps } from "./utils/helpers";

const hostname = window.location.hostname;
export const baseUrl = process.env.REACT_APP_DEV_MODE==="true"?`http://${hostname}:8000/api/v1`:`https://${hostname}/api/v1`;
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? "";
export const qburstAppsUrl = process.env.REACT_APP_QB_APPS_URL ?? "";

function getSupersetBaseUrl(): string | undefined {
  if (isAccessedFromQBurstApps()) {
    console.log("qb apps superset url", process.env.REACT_APP_QBURST_APPS_SUPERSET_BASE_URL);
    return process.env.REACT_APP_QBURST_APPS_SUPERSET_BASE_URL;
  }
  return process.env.REACT_APP_SUPERSET_BASE_URL;
}
export const supersetBaseUrl = getSupersetBaseUrl();